module.exports = __webpack_public_path__ + "img/2.f614fcc2.png";